import { useQuery } from '@tanstack/react-query';
import type { ICurrentUserInfoResponse } from '@treneo/models';
import { ResultHelpers } from '@treneo/models';

import { usersApi } from './api';
import { CURRENT_USER_QUERY_KEY } from './user-query-keys';

export { CURRENT_USER_QUERY_KEY } from './user-query-keys';

const getCurrentUserQueryFn = async (): Promise<ICurrentUserInfoResponse> => {
  const result = await usersApi.getCurrentUser(true);
  return ResultHelpers.unwrap(result, 'Get current user info failed');
};

export const getCurrentUserQueryOptions = (enabled: boolean) => ({
  queryKey: CURRENT_USER_QUERY_KEY,
  queryFn: getCurrentUserQueryFn,
  enabled,
  staleTime: 2 * 60 * 1000
});

export const useCurrentUserQuery = (options: { enabled: boolean }) =>
  useQuery(getCurrentUserQueryOptions(options.enabled));
